// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './backend'
import cable from './action_cable'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import datePicker from 'vue-bootstrap-datetimepicker'
import moment from 'vue-moment'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUserCircle,
  faQuestionCircle,
  faExternalLinkAlt,
  faPen,
  faReply,
  faUserPlus,
  faFlag,
  faPlusCircle,
  faTrash,
  faCompress,
  faSyncAlt,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faTags,
  faTasks,
  faUserCheck,
  faEnvelopeOpen,
  faUser,
  faTrashAlt,
  faEllipsisV,
  faEnvelope,
  faUsers,
  faAddressCard,
  faPuzzlePiece,
  faIdBadge,
  faClone,
  faLayerGroup,
  faTimesCircle,
  faAngleDoubleRight,
  faCheckCircle,
  faHandPointer,
  faBars,
  faSearch,
  faTimes,
  faArrowsAltV,
  faLongArrowAltDown,
  faLongArrowAltUp
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vSelect from 'vue-select'
import Quill from 'quill'
import VueQuillEditor from 'vue-quill-editor'
import VueConfetti from 'vue-confetti'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ImageResize from 'quill-image-resize-module'
import AtTa from 'vue-at/dist/vue-at-textarea'
import At from 'vue-at'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import mapInit from 'highcharts/modules/map'
import GrammarlyInline from '../config/grammarly'
mapInit(Highcharts)
Vue.use(HighchartsVue)
library.add(
  faUserCircle,
  faQuestionCircle,
  faExternalLinkAlt,
  faPen,
  faReply,
  faUserPlus,
  faFlag,
  faPlusCircle,
  faTrash,
  faCompress,
  faSyncAlt,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faTags,
  faTasks,
  faUserCheck,
  faEnvelopeOpen,
  faUser,
  faTrashAlt,
  faEllipsisV,
  faEnvelope,
  faUsers,
  faAddressCard,
  faPuzzlePiece,
  faIdBadge,
  faClone,
  faLayerGroup,
  faTimesCircle,
  faAngleDoubleRight,
  faCheckCircle,
  faHandPointer,
  faBars,
  faSearch,
  faTimes,
  faArrowsAltV,
  faLongArrowAltDown,
  faLongArrowAltUp
)

Vue.component('fa', FontAwesomeIcon)

Vue.component('v-select', vSelect)
Vue.component('at', At)
Vue.component('at-ta', AtTa)
Vue.config.productionTip = false
// eslint-disable-next-line
Vue.use(BootstrapVue)
Vue.use(datePicker)
Vue.use(VueQuillEditor)
Vue.use(moment)
Vue.use(VueConfetti)
Quill.register('modules/imageResize', ImageResize)
Quill.register({'formats/grammarly-inline': GrammarlyInline})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  cable,
  components: { App, At },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js